export default __webpack_public_path__ + "static/media/georges.fb9c308d.png";